import { makeObservable, observable } from 'mobx'
import { EMPTY_NUMBER_ID } from 'src/constant/common'
import { UndoableDTO } from 'src/dto/UndoableDTO'
import { typeSafeAssign } from '@/utils/common'

export class ProblemScoring extends UndoableDTO {
  worksheetProblemId: number = EMPTY_NUMBER_ID
  result: common.ScoringResult = 'CORRECT'
  virtualResult: common.ScoringResult = 'NONE'
  virtualUserAnswer: string = ''

  constructor(
    data?: res.GroupStudentWorksheetProblem['scoringList'][number] & {
      virtualResult: common.ScoringResult
      virtualUserAnswer: string
    },
  ) {
    super()
    makeObservable(this, {
      worksheetProblemId: observable,
      result: observable,
      virtualResult: observable,
      virtualUserAnswer: observable,
    })

    if (data) typeSafeAssign(this, data)
  }
}
